<template>
    <div v-show="state.visible" class="notification-modal" :style="{ zIndex: state.zIndex }">
        <Teleport to="body">
            <div
                v-show="state.visible"
                class="global-nm-mask"
                :style="{ zIndex: state.zIndexMask }"></div>
        </Teleport>
        <img class="nm-bg" src="@/assets/images/notification-modal-bg.png" />
        <div class="content">
            <div class="nm-title">公告</div>
            <div class="nm-list">
                <div class="nm-item" v-for="item in state.list" :key="item.id" @click="remarkModal(item.raw)">
                    <div class="nm-item-c">
                        <div class="nm-item-h">
                            <div class="nm-item-title">{{ item.title }}</div>
                            <div class="nm-item-date">{{ item.date }}</div>
                        </div>
                        <div class="nm-item-body">{{ item.content }}</div>
                    </div>
                    <span class="nm-icon-ar el-submenu__icon-arrow el-icon-arrow-right"></span>
                </div>
            </div>
        </div>
        <img class="nm-x" src="@/assets/images/notification-modal-x.png" @click="state.visible = false" />
    </div>
</template>

<script setup>
import { reactive, onMounted, ref } from 'vue'
import { useAction } from '@/hooks/useAction'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { queryNotifyInfo, readNotify } from '@/api/order/noticeManage.js'
import { Assertion } from '@annto/fe-utils/lib/assertion'
import { ElMessageBox } from 'element-plus'
import PopupManager from 'element-plus/es/utils/popup-manager'

const router = useRouter()
const route = useRoute()
const store = useStore()

const state = reactive({
    zIndex: 9999,
    zIndexMask: 9998,
    visible: false,
    haveShown: false,
    fetched: false,
    list: [
        // {
        //     title: '公告标题备份',
        //     content: '公告内容公告内容公告内容公告内容公告内容',
        //     date: '2024-03-16 12:56:55',
        // },
        // {
        //     title: '公告标题备份',
        //     content: '公告内容公告内容公告内容公告内容公告内容',
        //     date: '2024-03-16 12:56:55',
        // },
        // {
        //     title: '公告标题备份',
        //     content: '公告内容公告内容公告内容公告内容公告内容',
        //     date: '2024-03-16 12:56:55',
        // },
    ],
})

const fetchData = useAction(async () => {
    return queryNotifyInfo({
        pageNo: 1,
        pageSize: 3,
        param: {
            source: '1', // 李磊: 来源: 1弹框,2查询，货主弹框查询必输
            notifyCustomerCode: store.state.user.identityInfo.customerCode,
        },
    })
        .then(Assertion.assertResponseIsSuccessWithData)
        .then(res => {
            state.fetched = true
            state.list = (res.data.list || []).map(item => {
                return {
                    raw: item,
                    id: item.id,
                    title: item.notifyTitle,
                    date: item.createTime,
                    content: removeTags(item.remark),
                }
            })
        })
})

const checkOpenModal = async route => {
    // console.log('checkOpenModal', route)
    if (!state.fetched) {
        await fetchData.action()
    }

    if (!state.haveShown && ['/mod/ntp/index'].includes(route.path)) {
        if (state.list.length > 0) {
            setTimeout(() => {
                show()
            }, 1000) // HACK: 让公告弹框显示在告警信息弹框上面
        }
    }
}

const show = () => {
    state.zIndexMask = PopupManager.nextZIndex()
    state.zIndex = PopupManager.nextZIndex()
    state.visible = true
    state.haveShown = true
}

onMounted(async () => {
    await fetchData.action()
    checkOpenModal(route)
})

router.afterEach(async to => {
    checkOpenModal(route)
})

// 通知内容
const remarkModal = (row, title = '通知内容') => {
    ElMessageBox.alert(row.remark, title, {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        customClass: 'remark-class',
    }).catch(() => {})
    readNotify({ notifyNo: row.notifyNo })
}

function removeTags(str) {
    if (str === null || str === '') return ''
    else str = str.toString() // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, '')
}
</script>

<style lang="less">
.global-nm-mask {
    position: fixed;
    inset: 0;
}
</style>

<style lang="less" scoped>
.notification-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 720px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 1px 1px 10px 10px #8884;
    transform: translate(-50%, -50%);

    .nm-bg {
        margin: -10px -2px -6px;
        width: calc(100% + 4px);
    }

    .nm-x {
        position: absolute;
        cursor: pointer;
        top: 10px;
        right: 18px;
        width: 20px;
        height: 20px;
    }

    .content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        .nm-title {
            margin-top: 24px;
            font-size: 1.2rem;
            text-align: center;
            font-weight: bold;
        }

        .nm-list {
            padding: 0;
            margin: 20px;
        }

        .nm-item {
            position: relative;
            display: flex;
            align-items: center;
            padding: 18px 10px 18px 20px;
            margin-bottom: 12px;
            color: #676767;
            background: #fff;
            border: 1px solid rgba(83, 83, 83, 0.1);
            border-radius: 8px;
            line-height: 20px;

            .nm-item-c {
                flex-grow: 1;
                max-width: calc(100% - 20px);
            }

            &:hover {
                border: 1px solid #1677ff;
                cursor: pointer;

                .nm-item-h .nm-item-title {
                    color: #1677ff;
                }

                .nm-icon-ar {
                    color: #1677ff;
                }
            }

            .nm-item-h {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 6px;
                font-size: 0.96rem;

                .nm-item-title {
                    font-weight: bold;
                    color: #000;
                }
            }

            .nm-item-body {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .nm-icon-ar {
            right: 10px;
            text-align: right;
        }
    }
}
</style>
